export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('MUST_HAVE_DATE_OR_EXERCICE') === 0) {
      messages.push({
        message: 'situation.error.mustHaveDateOrExercice',
      });
    }
    if (message.indexOf('MUST_HAVE_DATE_START_AND_DATE_END') === 0) {
      messages.push({
        message: 'situation.error.mustHaveDate',
      });
    }
  });
}
